module.exports = __webpack_public_path__ + "static/media/hall-P3.56fe51c8.svg";